import React from 'react'

import withRenderModal from 'hocs/withRenderModal'
import Button from 'atoms/Button'

import Modal from 'molecules/Modal'
import { StyledCustomSelect } from 'pages/Vehicle/Vehicle.style'

import { FormikProvider } from 'formik'
import { useAddVehicleModal } from './useAddVehicleModal'
import styled from 'styled-components'
import TextField from 'molecules/CustomTextField/CustomTextField'
import ButtonLink from 'atoms/ButtonLink'

type WarningModalProps = {
  data: {
    message: string
    iceChassisOptions: any
    evChassisOptions: any
    hvVehicleWeightClass: any
    fuel_type: any
    ice_chassis: any
    replacement_electric_vehicle_chassis: any
    hvTcoData: any
    heavy_vehicle_weight_class: any
  }
  closeModal: () => void
  onHandleClickUpdate: any
  onHandleClickAddvehicle: any
}

const AddVehicleModal = ({
  closeModal,
  data,
  onHandleClickUpdate,
  onHandleClickAddvehicle,
}: WarningModalProps) => {
  const vehicle_fuel_type = data.fuel_type

  const {
    hvVehicleWeightClass,
    ice_chassis,
    replacement_electric_vehicle_chassis,
    hvTcoData,
    evChassisOptions,
    iceChassisOptions,
    heavy_vehicle_weight_class,
  } = data

  const { formik } = useAddVehicleModal({
    onHandleClickUpdate,
    onHandleClickAddvehicle,
    fuel_type: vehicle_fuel_type,
    hvTcoData,
    replacement_electric_vehicle_chassis,
    ice_chassis,
    hvVehicleWeightClass,
    heavy_vehicle_weight_class,
  })

  const {
    ice_chassis: formik_ice_chassis,
    replacement_electric_vehicle_chassis: formik_ev_chassis,
  } = formik.values

  const disable_ice_chassis =
    vehicle_fuel_type === 'diesel' && formik_ice_chassis && formik_ice_chassis !== 'custom'
  const disable_ev_chassis =
    vehicle_fuel_type === 'electric' && formik_ev_chassis && formik_ev_chassis !== 'custom'

  const disable_values = vehicle_fuel_type === 'diesel' ? disable_ice_chassis : disable_ev_chassis

  return (
    <Modal
      header={
        vehicle_fuel_type === 'diesel' ? 'Add/ Update ICE chassis' : 'Add/ Update ZeV chassis'
      }
      footer={
        <StyledFooterContainer>
          <ButtonLink style={{}} onClick={closeModal}>
            Cancel
          </ButtonLink>
          <Button color="socondary" onClick={formik.handleSubmit}>
            Add vehicle
          </Button>
        </StyledFooterContainer>
      }
    >
      <FormikProvider value={formik}>
        <StyledBodyContainer className="body">
          <StyledColumnContainer>
            <StyledCustomSelect
              mandatory
              name="heavy_vehicle_weight_class"
              labelColor="#000"
              placeholder="Asset class"
              label="Asset class"
              options={hvVehicleWeightClass}
              disabled
            />
            {vehicle_fuel_type === 'electric' ? (
              <StyledCustomSelect
                mandatory
                name="replacement_electric_vehicle_chassis"
                labelColor="#000"
                placeholder="Replacement ZeV chassis"
                label="Replacement ZeV chassis"
                options={[...evChassisOptions, { value: 'custom', label: 'Custom' }]}
                additionalInfo
              />
            ) : (
              <StyledCustomSelect
                mandatory
                name="ice_chassis"
                labelColor="#000"
                placeholder="ICE vehicle chassis"
                label="ICE vehicle chassis"
                options={[...iceChassisOptions, { value: 'custom', label: 'Custom' }]}
                additionalInfo
              />
            )}
          </StyledColumnContainer>
          <StyledFullColumn>
            <TextField
              disabled={disable_values}
              mandatory
              name="make"
              labelColor="#000"
              placeholder="make"
              label="make"
            />
            <TextField
              disabled={disable_values}
              mandatory
              name="model"
              labelColor="#000"
              placeholder="model"
              label="model"
            />
            {/* <TextField
              mandatory
              name="variant"
              labelColor="#000"
              placeholder="variant"
              label="variant"
              disabled={disable_values}
            /> */}
          </StyledFullColumn>
          <StyledFullColumn>
            <TextField
              mandatory
              name="payload"
              labelColor="#000"
              placeholder="payload"
              label="Max payload"
              adornment={'kg'}
              adornmentPosition="right"
            />
          </StyledFullColumn>
          <StyledFullColumn>
            {vehicle_fuel_type === 'electric' && (
              <TextField
                mandatory
                name="battery"
                labelColor="#000"
                placeholder="Battery size"
                label="Battery size"
                adornment={'kWh'}
                adornmentPosition="right"
              />
            )}

            {vehicle_fuel_type === 'electric' ? (
              <>
                <TextField
                  mandatory
                  name="efficiency"
                  labelColor="#000"
                  placeholder="Efficiency"
                  label="Rated efficiency at kerb mass"
                  adornment={'kWh/100 km'}
                  adornmentPosition="right"
                />
                <TextField
                  mandatory
                  name="range"
                  labelColor="#000"
                  placeholder="Range"
                  label="Range"
                  adornment={'km'}
                  adornmentPosition="right"
                />
              </>
            ) : (
              <>
                <TextField
                  mandatory
                  name="efficiency"
                  labelColor="#000"
                  placeholder="Efficiency"
                  label="Rated efficiency at kerb mass"
                  adornment={'L/100 km'}
                  adornmentPosition="right"
                />
                <TextField
                  mandatory
                  name="battery"
                  labelColor="#000"
                  placeholder="Fuel tank capacity"
                  label="Fuel tank capacity"
                  adornment={'Liters'}
                  adornmentPosition="right"
                />
              </>
            )}
          </StyledFullColumn>
          <StyledFullColumn>
            <TextField
              mandatory
              name="service_cost_km"
              labelColor="#000"
              placeholder="Cost"
              label="Service cost (A$)"
              adornment={'per km'}
              adornmentPosition="right"
            />
            <TextField
              mandatory
              name="tyre_cost_km"
              labelColor="#000"
              placeholder="Cost"
              label="Tyre cost (A$)"
              adornment={'per km'}
              adornmentPosition="right"
            />
          </StyledFullColumn>
          <StyledFullColumn>
            <TextField
              mandatory
              name="chassis_cost"
              labelColor="#000"
              placeholder="Chassis cost"
              label="Chassis cost"
              adornment={'A$'}
              adornmentPosition="left"
            />
          </StyledFullColumn>
        </StyledBodyContainer>
      </FormikProvider>
    </Modal>
  )
}

export default withRenderModal('add-vehicle-modal')(AddVehicleModal)

const StyledColumnContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 34px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`

const StyledFullColumn = styled.div`
  display: grid;
  grid-template-columns: 1.1fr 1.2fr 0.7fr;
  gap: 35px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`

// const StyledFullColumnEdit = styled(StyledFullColumn)`
//   grid-template-columns: 162px 0.6fr;
// `

const StyledBodyContainer = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  gap: 30px;
`

const StyledFooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`
